/* eslint-disable fp/no-mutation */
import { colors } from '@frontend/constants';

const MARKER_COLORS = [colors.blue[600], colors.orange[600], colors.teal[600], colors.violet[700], colors.pink[700]];

export const getMarkerColor = (index: number) => MARKER_COLORS[index % MARKER_COLORS.length] ?? MARKER_COLORS[0]!;

const MARKER_TRANSITION = 'transition:transform .15s ease,opacity .15s ease,filter .15s ease';

export const createLabelMarker = (label: string, bgColor: string) => {
  const el = document.createElement('div');
  el.textContent = label;
  el.style.cssText = [
    `background:${bgColor};color:#fff`,
    'padding:4px 8px;border-radius:4px',
    'font-size:12px;font-weight:500;white-space:nowrap',
    'box-shadow:0 2px 6px rgba(0,0,0,.25)',
    'cursor:pointer',
    MARKER_TRANSITION,
  ].join(';');
  return el;
};

const ICON_MASK_STYLE = [
  'width:18px;height:18px;background-color:white',
  '-webkit-mask-size:contain;mask-size:contain',
  '-webkit-mask-repeat:no-repeat;mask-repeat:no-repeat',
  '-webkit-mask-position:center;mask-position:center',
].join(';');

const TEARDROP_STYLE = [
  'width:36px;height:36px;border-radius:50% 50% 50% 0',
  'border:2px solid white;transform:rotate(-45deg)',
  'display:flex;align-items:center;justify-content:center',
  'box-shadow:0 2px 8px rgba(0,0,0,.3)',
].join(';');

export const createIconMarker = (svgMaskUrl: string, bgColor: string) => {
  const el = document.createElement('div');
  el.style.cssText = `cursor:pointer;${MARKER_TRANSITION}`;

  const teardrop = document.createElement('div');
  teardrop.style.cssText = `${TEARDROP_STYLE};background:${bgColor}`;

  const rotator = document.createElement('div');
  rotator.style.cssText = 'transform:rotate(45deg);display:flex';

  const icon = document.createElement('div');
  icon.style.cssText = `${ICON_MASK_STYLE};-webkit-mask-image:url(${svgMaskUrl});mask-image:url(${svgMaskUrl})`;

  rotator.appendChild(icon);
  teardrop.appendChild(rotator);
  el.appendChild(teardrop);
  return el;
};

/* eslint-enable fp/no-mutation */
